import type { Table } from '@wmt/content-blocks'
import type { FilteredSchema, PlayerRoster } from '~/types'
import { toFloatByPath } from '~/statistics/utils/toFloatByPath'
import { defaultBodyCells, defaultColumns } from '~/statistics/playerRosters/aliases'
import { getSortAsNumber } from '~/shared/lib/sorts'

export const columns: Table.Cell<PlayerRoster.Model>[] = [
  { content: 'Plays', sort: true },
  { content: 'Rush', sort: true },
  { content: 'Pass', sort: true },
  { content: 'Rec', sort: true },
  { content: 'Total', sort: true },
  { content: 'Avg/G', sort: true },
]

export const cells: Table.BodyCell<PlayerRoster.Model>[] = [
  { content: '$get(statistics.totOffPlays, 0)' },
  { content: '$get(statistics.rushing.yards, 0)' },
  { content: '$get(statistics.passing.yards, 0)' },
  { content: '$get(statistics.receiving.yards, 0)' },
  { content: '$get(statistics.allPurposeYards, 0)' },
  { content: (player: PlayerRoster.Model) => toFloatByPath(player, 'statistics.allPurposeAvg'), onSort: getSortAsNumber },
]

export const playerRosterAllPurposeYardageStatsSchema: FilteredSchema<PlayerRoster.Model> = {
  filter: player => Boolean(player.statistics?.receiving),
  schema: {
    head: {
      rows: [
        {
          cells: [
            ...defaultColumns,
            ...columns,
          ],
        },
      ],
    },
    body: {
      rows: {
        cells: [
          ...defaultBodyCells,
          ...cells,
        ],
      },
    },
  },
}
